import { parseFromQuery } from '@pray/shared/utils/parseFromQuery';

const MAX_SOURCE_LENGTH = 50;

/**
 * Computes the UI-surface `source` attribution value sent on subscription /
 * donation API calls (POST /web/users/:id/donations,
 * POST /web/users/:id/products/:id/purchases, etc.).
 *
 * Precedence:
 *   1. A `source` query parameter on the current URL (e.g. server-generated
 *      deeplinks carrying explicit attribution).
 *   2. The caller-supplied `pageDefault` (e.g. 'email-onboarding').
 *
 * Returns `undefined` when neither is available so the server keeps its
 * default NULL behavior.
 *
 * IMPORTANT: This is NOT for UTM. utm_source / utm_medium / utm_campaign
 * are a separate marketing-attribution dimension already captured by
 * `eventTracking._addUtmQueryParams` on Amplitude events.
 *
 * The server enforces max 50 chars (`source: z.string().max(50).optional()`);
 * values longer than that — from either the URL or the caller — are ignored so
 * a malformed deeplink or a future caller passing a long campaign string does
 * not 400 the checkout call.
 */
export function getAttributionSource(pageDefault?: string): string | undefined {
  const urlSource = parseFromQuery('source') as string | null | undefined;

  if (urlSource && typeof urlSource === 'string' && urlSource.length <= MAX_SOURCE_LENGTH) {
    return urlSource;
  }

  if (pageDefault && pageDefault.length <= MAX_SOURCE_LENGTH) {
    return pageDefault;
  }

  return undefined;
}
